"use client";

import { Search, X } from "lucide-react";
import { useState, useEffect } from "react";
import styles from "./news.module.css";

interface Props {
  onSearch?: (q: string) => void;
}

export default function SearchBar({ onSearch }: Props) {
  const [text, setText] = useState("");

  // Debounce 300ms
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (onSearch) onSearch(text);
    }, 300);

    return () => clearTimeout(timeout);
  }, [text]);

  return (
    <div className={styles.searchWrapper}>
      <div className={styles.searchBarModern}>
        <Search className={styles.icon} />

        <input
          className={styles.inputModern}
          type="text"
          placeholder="Tìm kiếm bài viết..."
          value={text}
          onChange={(e) => setText(e.target.value)}
        />

        {text && (
          <X
            className={styles.clearBtn}
            onClick={() => setText("")}
          />
        )}
      </div>
    </div>
  );
}